<template>
  <v-dialog
    v-model="visibility"
    max-width="500"
    persistent
  >
    <v-card>
      <div class="px-0">
        <v-card-title class="headline pl-4 py-2 pr-2">
          Udostępnij na Google Drive
          <v-spacer></v-spacer>
          <v-btn
            @click.native="visibility = false"
            icon>
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="px-4">
          Czy napewno chcesz udostępnić plik na Google Drive?
        </v-card-text>

        <v-card-actions class="px-4 py-4">
          <v-spacer></v-spacer>

          <v-btn
            color="primary lighten-2"
            flat="flat"
            @click="setVisbility"
          >
            Anuluj
          </v-btn>

          <v-btn
            color="primary"
            :loading="busy"
            :disabled="busy"
            @click="shareFile"
          >
            Udostępnij
          </v-btn>
        </v-card-actions>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { googleShare } from '../../../repository/files';

export default {
  name: 'share-dialog',
  data: () => ({
    busy: false,
    errorMsg: null,
    error: null,
  }),
  computed: {
    ...mapGetters('files', [
      'dialogVisibility',
    ]),
    visibility: {
      get() {
        return this.dialogVisibility.type === 'share';
      },
      set(val) {
        this.setDialogVisbility(val);
      },
    },
  },
  methods: {
    ...mapActions('files', [
      'setDialogVisbility',
    ]),
    ...mapActions('app', [
      'setSnackBar',
    ]),
    setVisbility() {
      this.setDialogVisbility(false);
    },
    async shareFile() {
      this.busy = true;
      try {
        this.busy = false;
        await googleShare(this.dialogVisibility.item_id);
        this.setSnackBar('Plik został udostępniony na twoim dysku Google Drive.');
      } catch (e) {
        this.busy = false;
      }
    },
  },
};
</script>
